<template>
    <section>
        <p class="title is-3">Agregar Contacto</p>
    
        <form-cliente :cliente="datosCliente" @registrar="onRegistrar"/>
        <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
    </section>
</template>
<script>
    import FormCliente from './FormCliente'
    import HttpService from '../../Servicios/HttpService'

    export default{
        name: "AgregarCliente",
        components: { FormCliente },

        data: ()=>({
            cargando: false,
            datosCliente: {
                nombre: "",
                telefono: "",
                ciudad:"",
                placa:"",
                idCategoria:"",
                nombreCategoria:"",
               
            }
        }),

        methods: {
            onRegistrar(cliente){
                console.log(cliente)
                this.cargando = true
                let payload = {
                    accion: "registrar",
                    cliente: cliente
                }
                HttpService.registrar("clientes.php", payload)
                .then(registrado =>{
                    if(registrado){
                        this.$buefy.toast.open({
                          type: 'is-info',
                          message: 'Cliente registrado con éxito.'
                        })
                        this.cargando = false
                    }
                })
            }
        }
    }
</script>

<style scoped>
.title {
    display: flex;
    justify-content: center;
}

</style>